import { render, staticRenderFns } from "./PreviewKeys.vue?vue&type=template&id=72f80493&scoped=true&"
import script from "./PreviewKeys.vue?vue&type=script&lang=ts&"
export * from "./PreviewKeys.vue?vue&type=script&lang=ts&"
import style0 from "./PreviewKeys.vue?vue&type=style&index=0&id=72f80493&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f80493",
  null
  
)

export default component.exports